'use client';

import { useEffect } from 'react';

export default function ExternalLinksHandler() {
  useEffect(() => {
    const applyNofollow = () => {
      const links = document.querySelectorAll('a[href^="http"]');
      links.forEach((link) => {
        const anchor = link as HTMLAnchorElement; // cast to HTMLAnchorElement
        if (!anchor.href.includes('cliniconnect.org')) {
          anchor.setAttribute('rel', 'nofollow noopener noreferrer');
          anchor.setAttribute('target', '_blank');
        }
      });
    };

    applyNofollow();

    // Watch for dynamically added links
    const observer = new MutationObserver(() => {
      applyNofollow();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return null;
}
